import { apiService } from './api';

export interface AttendanceData {
  attendanceId: number;
  clockIn: string;
  clockOut: string;
  attendanceDate: string;
  requireComment: boolean;
}

class AttendanceService
{
  async getAttendanceByPersonId(timezone: string): Promise<AttendanceData>
  {
    return apiService.get<AttendanceData>(
      `Attendance/GetAttendanceByPersonId?timezone=${timezone}`,
    );
  }

  async submitAttendanceByPersonId(comment: string, timezone: string): Promise<AttendanceData>
  {
    return apiService.post<AttendanceData>(
      `Attendance/SubmitAttendanceByPersonId?comment=${encodeURIComponent(comment)}&timezone=${timezone}`,
    );
  }

  async getCommentsList(): Promise<string[]>
  {
    return apiService.get<string[]>('Attendance/GetCommentsList');
  }
}

export const attendanceService = new AttendanceService();
